import { FC, ReactNode } from 'react';

import { Link, rem } from '@bonusly/design-system';

type UserNavLinkExternalProps = {
	children: ReactNode;
	href: string;
};

export const UserNavLinkExternal: FC<UserNavLinkExternalProps> = ({ children, href, ...props }) => {
	return (
		<Link href={href} w="100%" py={rem(8)} px={rem(10)} borderRadius="md" _hover={{ bg: 'secondary.bgAlpha', textDecoration: 'none' }} {...props}>
			{children}
		</Link>
	);
};
